import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Form, Message, Row } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ReviewSummaryResultForm from '../../components/forms/reviewSummaryForm/ReviewSummaryResultForm'
import ReviewSummaryForm from '../../components/forms/reviewSummaryForm/ReviewSummaryForm'
import { saveReviewSummary } from '../../redux/actions/reviewSummary'
import { startLoading, doneLoading } from '../../utils/loading'
import ExpertResultListTable from '../../components/table/expertResultListTable/expertResultListTable'
import ApprovedExpertListTable from '../../components/table/approvedExpertListTable/ApprovedExpertListTable'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { saveSubProjectReviewSummary } from '../../redux/actions/reviewSummary'
import ReviewSumarySubprojectUploadFileWidget from '../../widgets/reviewSumarySubprojectUploadFileWidget/ReviewSumarySubprojectUploadFileWidget'
import moment from 'moment'
import notification from '../../utils/notification'
import { SAVE_SUCCESS_MSG } from '../../constants/msgText'

export default function ReviewSummaryResultSubProject({
  schema,
  onComplete,
  selectedExpert,
  requiredSelectedExpert,
}) {
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const dispatch = useDispatch()
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(schema)
  const [request, setRequest] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  const handleSaveReviewSummary = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const response = await saveSubProjectReviewSummary(projectId, request)
      console.log('response', response)
      if (response) {
        setIsLoading(false)
        doneLoading()

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
        
        if(request.reviewerFilter == 2 || request.reviewerFilter == 3){
          return history.push(`${pathname.subProject.overviewSubProject}`)
        }
      }
    } catch (e) {
      console.log(e?.response?.data)
      if (e?.response?.data) {
        setIsError(e.response.data.errorMessage)
      } else {
        setIsError('เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    // console.log('Submit data', data)

    const _selectedExpert = selectedExpert.filter((item) => item.isSelected)
    console.log('_selectedExpert', _selectedExpert)

    let request = {
      //id: 'string',
      projectVersionId: projectId,
      //userId: 'string',
      reviewResult: data.reviewResult,
      reviewerFilter: data.reviewerFilter,
      // dateOfScrutinize: data.dateOfScrutinize,
      dateOfScrutinize: moment(data.dateOfScrutinize).format('DD/MM/YYYY'),
      // dateOfScrutinizeRes: data.dateOfScrutinizeRes,
      dateOfScrutinizeRes: moment(data.dateOfScrutinizeRes).format('DD/MM/YYYY'),
      reviewerItems: _selectedExpert,
    }

    setRequest(request)

    //validate required selected Expert
    if (_selectedExpert.length >= requiredSelectedExpert) {
      setIsShowConfirm(true)
      setIsError()
    } else {
      setIsError('ต้องการผู้ทรงคุณวุฒิอย่างน้อย ' + requiredSelectedExpert + ' คน')
    }
  }

  const onConfirm = () => {
    setIsShowConfirm(false)
    handleSaveReviewSummary()
  }

  const onCancle = () => {
    setIsShowConfirm(false)
  }

  console.log('formSchema?.disabled ', formSchema?.disabled)

  return (
    <>
      <Form fluid>
        {/* <Panel shaded header={formSchema.reviewerApproveList.header} bordered collapsible defaultExpanded>
          <ApprovedExpertListTable
            data={formSchema.reviewerApproveList?.itemsList}
            hideRound={true}
            hideInviteLetter={true}
          />
        </Panel> */}
        {/* <Panel shaded header="" bordered collapsible defaultExpanded>
          <ReviewSummaryResultForm
            schema={formSchema.reviewerSummary}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
        </Panel>
        <br /> */}
        <Panel
          shaded
          header={formSchema.ReviewApproveAndSummary.reviewerSummary.reviewResult.label}
          bordered
          collapsible
          defaultExpanded
        >
          <ReviewSummaryForm
            schema={formSchema.ReviewApproveAndSummary.reviewerSummary}
            isSubProject={true}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            disabledForm={formSchema?.ReviewApproveAndSummary?.disabled}
          />
          <br />
          {formSchema?.UploadDocuments && (
            <ReviewSumarySubprojectUploadFileWidget
              showCommandButton={
                formSchema?.disabled || formSchema?.ReviewApproveAndSummary.disabled
              }
              schema={formSchema.UploadDocuments}
            />
          )}
          <hr />
          {isError && (
            <Row style={{ marginBottom: 10 }}>
              <Message showIcon type="error" description={isError} />
            </Row>
          )}
          <SaveButton
            onClick={handleSubmit(onSubmit)}
            disabled={isLoading || formSchema?.ReviewApproveAndSummary.disabled}
          >
            บันทึกผลการพิจารณากลั่นกรอง
          </SaveButton>
        </Panel>
        <br />
      </Form>

      <ConfirmWidget
        title={`ยืนยันการบันทึกผลการพิจารณากลั่นกรอง`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการบันทึกผลการพิจารณากลั่นกรอง`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </>
  )
}
